// imports react
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export function LoginBaseBoard() {
  const navigateTo = useNavigate();

  function navigateToTerms() {
    window.open('https://evoktm.com.br/termos.html', '_blank');
  }

  function navigateToPlans() {
    window.open('https://evoktm.com.br/#plans', '_blank');
  }

  function navigateToContact() {
    window.open('https://evoktm.com.br/politica.html', '_blank');
  }

  return (
    <div className="w-full max-w-lg d-flex flex-col lg:flex-row justify-between px-10 mx-auto">
      <div className="d-flex flex-col lg:flex-row fw-semibold text-primary fs-base gap-5">
        <strong
          className="link-primary cursor-pointer"
          onClick={navigateToTerms}
        >
          Termos
        </strong>
        <strong
          className="link-primary cursor-pointer"
          onClick={navigateToPlans}
        >
          Planos
        </strong>
        <strong
          className="link-primary cursor-pointer"
          onClick={navigateToContact}
        >
          Política
        </strong>
      </div>
    </div>
  );
}
